import { some } from 'lodash'

const order = {
  hasFreeDelivery: root => some(root.priceLines, { type: 'free-delivery-cost' }),
}

export default order
